import { Tabs, TabsList, TabsTrigger } from "@repo/shad/ui/tabs"
import { Link, Outlet, createFileRoute, useMatches } from "@tanstack/react-router"
import { FileSignature, FileText, Package } from "lucide-react"

import { useDocsFeatureEnabled } from "@/features/docs/feature-gate"

export const Route = createFileRoute("/$dealership/deal-packets")({
  staticData: {
    breadcrumb: "Deal Signing",
  },
  component: DealsLayout,
})

function DealsLayout() {
  const matches = useMatches()
  const { dealership } = Route.useRouteContext()
  const slug = dealership?.slug ?? ""
  const { enabled: docsEnabled } = useDocsFeatureEnabled(dealership?._id)

  // Determine active tab from current route
  const isPresetRoute = matches.some((m) => m.fullPath.includes("/deal-packets/presets"))
  const isTemplateRoute = matches.some((m) => m.fullPath.includes("/deal-packets/templates"))
  const activeTab = isPresetRoute
    ? "presets"
    : isTemplateRoute && docsEnabled
      ? "templates"
      : "deals"

  // Hide tabs on detail pages (deal detail, template detail, field mapper)
  const isDetailPage = matches.some(
    (m) =>
      m.fullPath.includes("/deal-packets/$dealId") || m.fullPath.includes("/templates/$templateId"),
  )

  if (isDetailPage) {
    return <Outlet />
  }

  return (
    <div className="mx-auto max-w-7xl space-y-6 p-6 w-full">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <h1 className="text-2xl font-bold">Deal Signing</h1>
        <Tabs value={activeTab}>
          <TabsList>
            <TabsTrigger value="deals" asChild>
              <Link to="/$dealership/deal-packets" params={{ dealership: slug }} className="gap-2">
                <FileSignature className="h-4 w-4" />
                Deals
              </Link>
            </TabsTrigger>
            {docsEnabled ? (
              <TabsTrigger value="templates" asChild>
                <Link
                  to="/$dealership/deal-packets/templates"
                  params={{ dealership: slug }}
                  className="gap-2"
                >
                  <FileText className="h-4 w-4" />
                  Templates
                </Link>
              </TabsTrigger>
            ) : null}
            <TabsTrigger value="presets" asChild>
              <Link
                to="/$dealership/deal-packets/presets"
                params={{ dealership: slug }}
                className="gap-2"
              >
                <Package className="h-4 w-4" />
                Presets
              </Link>
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      <Outlet />
    </div>
  )
}
